import React, { FC } from 'react';
import styled from 'styled-components';
import { MainContent } from 'src/pages-all/master-page/components/main-content';
import { SubSectionHeadline } from 'src/pages-all/home/components/parts/default.parts';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { MainLayout } from 'src/pages-all/master-page/components/main-layout';
import { BulletPoints } from 'src/pages-all/home/components/parts/HowWeChooseElitetutors.parts';
import { colors } from 'styles/colors';
import { HomepageButtonLegacy } from 'src/pages-all/home/components/ActionButton';

const HowWeChooseSection = styled(MainLayout)<{ minHdDesktop: boolean }>`
  background-color: ${colors.white};
  background-image: linear-gradient(
    to bottom,
    ${colors.lightblueGray} 0px,
    ${colors.lightblueGray} 500px,
    ${colors.lightblueGray} 500px,
    #ffffff 100%
  );
  background-image: ${({ minHdDesktop }) =>
      minHdDesktop ? "url('/images/girl_with_questioncards.png')" : ''},
    linear-gradient(
      to bottom,
      ${colors.lightblueGray} 0px,
      ${colors.lightblueGray} 600px,
      ${colors.lightblueGray} 600px,
      #ffffff 100%
    );
  background-repeat: no-repeat;
  background-position: top right;
  background-size: ${({ minHdDesktop }) => (minHdDesktop ? 'auto 750px' : '')};
  padding: 0 16px;
`;

const ContentBox = styled.div`
  margin: 60px 0;
`;

export const HowWeChooseElitetutors: FC<{
  variant?: 'online-nachhilfe';
  tutorspacePlus?: boolean;
  tutorspacePremium?: boolean;
}> = ({ variant, tutorspacePlus, tutorspacePremium }) => {
  const { minHdDesktop } = useBreakpoints();
  return (
    <HowWeChooseSection minHdDesktop={minHdDesktop} id={'unsere-premiumtutoren'}>
      <MainContent>
        <SubSectionHeadline
          headline={translate(translationKeys.homepage.howWeChooseElitetutors.heading)}
          noHeadlineColor
          level={2}
        >
          <ContentBox>
            <BulletPoints />
            <HomepageButtonLegacy
              variant={variant}
              tutorspacePremium={tutorspacePremium}
              tutorspacePlus={tutorspacePlus}
            />
          </ContentBox>
        </SubSectionHeadline>
      </MainContent>
    </HowWeChooseSection>
  );
};
